module.exports = __webpack_public_path__ + "static/media/playstore.11964970.png";